interface CityForForms {
  label: string;
  options: {
    label: string;
    value: string;
    facility?: string;
  }[];
}

/** Alphabetically sorted */
export const citiesForForms: CityForForms[] = [
  {
    label: 'Arizona',
    options: [
      { label: 'Phoenix', value: 'Phoenix', facility: 'Phoenix' },
      { label: 'Tempe', value: 'Phoenix', facility: 'Tempe' },
    ],
  },
  {
    label: 'California',
    options: [
      { label: 'Los Angeles', value: 'Los Angeles', facility: 'Los Angeles' },
      { label: 'Van Nuys', value: 'Los Angeles', facility: 'Van Nuys' },
      {
        label: 'Culver City',
        value: 'Los Angeles',
        facility: 'Culver City',
      },
      {
        label: 'Pasadena',
        value: 'Los Angeles',
        facility: 'Pasadena',
      },
      {
        label: 'Lawndale',
        value: 'Los Angeles',
        facility: 'Lawndale',
      },
      {
        label: 'Long Beach',
        value: 'Los Angeles',
        facility: 'Long Beach',
      },
      {
        label: 'Anaheim',
        value: 'Orange County',
        facility: 'Anaheim',
      },
      {
        label: 'Costa Mesa',
        value: 'Orange County',
        facility: 'Costa Mesa',
      },
      {
        label: 'Santa Ana',
        value: 'Orange County',
        facility: 'Santa Ana',
      },
      { label: 'Sacramento', value: 'Sacramento', facility: 'Sacramento' },
      { label: 'San Diego', value: 'San Diego', facility: 'San Diego' },
      { label: 'Del Mar', value: 'San Diego', facility: 'Del Mar' },
      {
        label: 'Oceanside',
        value: 'San Diego',
        facility: 'Oceanside',
      },
      {
        label: 'San Francisco',
        value: 'San Francisco',
        facility: 'San Francisco',
      },
      {
        label: 'Sunnyvale',
        value: 'San Francisco',
        facility: 'Sunnyvale',
      },
      {
        label: 'Redwood City',
        value: 'San Francisco',
        facility: 'Redwood City',
      },
      {
        label: 'Oakland',
        value: 'San Francisco',
        facility: 'Oakland',
      },
      {
        label: 'Hayward',
        value: 'San Francisco',
        facility: 'Hayward',
      },
      { label: 'San Mateo', value: 'San Francisco', facility: 'San Mateo' },
      { label: 'San Jose', value: 'San Francisco', facility: 'San Jose' },
    ],
  },
  {
    label: 'Colorado',
    options: [
      { label: 'Denver', value: 'Denver', facility: 'Denver' },
      { label: 'Aurora', value: 'Denver', facility: 'Aurora' },
    ],
  },
  {
    label: 'District of Columbia',
    options: [
      {
        label: 'Washington',
        value: 'Washington DC',
        facility: 'Washington',
      },
    ],
  },
  {
    label: 'Florida',
    options: [
      { label: 'Miami', value: 'Miami', facility: 'Miami' },
      { label: 'Miami Beach', value: 'Miami', facility: 'Miami Beach' },
      {
        label: 'Fort Lauderdale',
        value: 'Miami',
        facility: 'Fort Lauderdale',
      },
      { label: 'Orlando', value: 'Orlando', facility: 'Orlando' },
    ],
  },
  {
    label: 'Georgia',
    options: [
      { label: 'Atlanta', value: 'Atlanta', facility: 'Atlanta' },
      { label: 'Decatur', value: 'Atlanta', facility: 'Decatur' },
    ],
  },
  {
    label: 'Idaho',
    options: [
      {
        label: 'Boise',
        value: 'Boise',
        facility: 'Boise',
      },
    ],
  },
  {
    label: 'Illinois',
    options: [{ label: 'Chicago', value: 'Chicago', facility: 'Chicago' }],
  },
  {
    label: 'Indiana',
    options: [
      {
        label: 'Indianapolis',
        value: 'Indianapolis',
        facility: 'Indianapolis',
      },
    ],
  },
  {
    label: 'Maryland',
    options: [
      { label: 'Baltimore', value: 'Baltimore', facility: 'Baltimore' },
    ],
  },
  {
    label: 'Massachusetts',
    options: [{ label: 'Boston', value: 'Boston', facility: 'Boston' }],
  },
  {
    label: 'Michigan',
    options: [{ label: 'Detroit', value: 'Detroit', facility: 'Detroit' }],
  },
  {
    label: 'Minnesota',
    options: [
      {
        label: 'Minneapolis',
        value: 'Minneapolis/St Paul',
        facility: 'Minneapolis',
      },
    ],
  },
  {
    label: 'Missouri',
    options: [
      { label: 'St. Louis', value: 'St. Louis', facility: 'St. Louis' },
      { label: 'Kansas City', value: 'Kansas City', facility: 'Kansas City' },
    ],
  },
  {
    label: 'Nevada',
    options: [
      { label: 'Las Vegas', value: 'Las Vegas', facility: 'Las Vegas' },
    ],
  },
  {
    label: 'New Jersey',
    options: [
      {
        label: 'Belleville',
        value: 'Essex County',
        facility: 'Belleville',
      },
      {
        label: 'Union City',
        value: 'Essex County',
        facility: 'Union City',
      },
    ],
  },

  {
    label: 'New York',
    options: [
      { label: 'New York', value: 'New York', facility: 'New York' },
      { label: 'Astoria', value: 'New York', facility: 'Astoria' },
      { label: 'Bronx', value: 'New York', facility: 'Bronx' },
      { label: 'Brooklyn', value: 'New York', facility: 'Brooklyn' },
    ],
  },
  {
    label: 'North Carolina',
    options: [
      { label: 'Charlotte', value: 'Charlotte', facility: 'Charlotte' },
    ],
  },
  {
    label: 'Ohio',
    options: [
      { label: 'Columbus', value: 'Columbus', facility: 'Columbus' },
      { label: 'Cleveland', value: 'Cleveland', facility: 'Cleveland' },
    ],
  },
  {
    label: 'Oregon',
    options: [{ label: 'Portland', value: 'Portland', facility: 'Portland' }],
  },
  {
    label: 'Pennsylvania',
    options: [
      {
        label: 'Philadelphia',
        value: 'Philadelphia',
        facility: 'Philadelphia',
      },
    ],
  },
  {
    label: 'Rhode Island',
    options: [
      { label: 'Providence', value: 'Providence', facility: 'Providence' },
    ],
  },
  {
    label: 'Tennessee',
    options: [
      { label: 'Nashville', value: 'Nashville', facility: 'Nashville' },
    ],
  },
  {
    label: 'Texas',
    options: [
      { label: 'Austin', value: 'Austin', facility: 'Austin' },
      { label: 'Dallas', value: 'Dallas', facility: 'Dallas' },
      { label: 'Plano', value: 'Dallas', facility: 'Plano' },
      { label: 'Fort Worth', value: 'Dallas', facility: 'Fort Worth' },
      { label: 'Houston', value: 'Houston', facility: 'Houston' },
      { label: 'San Antonio', value: 'San Antonio', facility: 'San Antonio' },
    ],
  },
  {
    label: 'Utah',
    options: [
      {
        label: 'Salt Lake City',
        value: 'Salt Lake City',
        facility: 'Salt Lake City',
      },
    ],
  },
  {
    label: 'Virginia',
    options: [
      { label: 'Richmond', value: 'Richmond', facility: 'Richmond' },
      {
        label: 'Alexandria',
        value: 'Washington DC',
        facility: 'Alexandria',
      },
    ],
  },
  {
    label: 'Washington',
    options: [{ label: 'Seattle', value: 'Seattle', facility: 'Seattle' }],
  },
  {
    label: 'Wisconsin',
    options: [
      { label: 'Milwaukee', value: 'Milwaukee', facility: 'Milwaukee' },
    ],
  },
  {
    label: 'Canada',
    options: [{ label: 'Toronto', value: 'Toronto', facility: 'Toronto' }],
  },
]
  .sort(byLabel)
  .map(({ label, options }) => ({
    label,
    options: options.sort(byLabel),
  }));

function byLabel(a: any, b: any) {
  return a.label.localeCompare(b.label);
}
